import { render, staticRenderFns } from "./BSJ_hard_disk_not_detected-modal.vue?vue&type=template&id=8d045fb6&scoped=true"
import script from "./BSJ_hard_disk_not_detected-modal.vue?vue&type=script&lang=js"
export * from "./BSJ_hard_disk_not_detected-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d045fb6",
  null
  
)

export default component.exports